/** M-WF-01 · Confronto in sola lettura tra la compilazione applicata e il Cartellino attuale. */
import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { TimesheetReview } from "./TimesheetReview";

export function TimesheetCompareDialog({ compare, onClose, causeLabel }) {
  const rows = compare?.preview || [];
  const differing = rows.filter((r) => r.kind !== "same").length;
  return (
    <Dialog open={!!compare} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl" data-testid="timesheet-compare-dialog">
        <DialogHeader>
          <DialogTitle>Confronto con il Cartellino · v{compare?.revision}</DialogTitle>
          <DialogDescription>
            {differing ? `${differing} giornate del Cartellino differiscono oggi dagli orari applicati.` : "Il Cartellino corrisponde agli orari applicati."}
          </DialogDescription>
        </DialogHeader>
        <TimesheetReview rows={rows} decisions={{}} onChange={() => {}} readOnly causeLabel={causeLabel} />
      </DialogContent>
    </Dialog>
  );
}

export default TimesheetCompareDialog;
